<template>
  <div class="comp-undoredosave">
    <div :class="['status', istatus]">
      <template v-if="istatus === 'updating'">
        <Icon name="refresh" /> wird gespeichert
      </template>
      <template v-else-if="istatus === 'updated'">
        <Icon name="checkmark" /> gespeichert
      </template>
      <template v-else-if="istatus === 'idle'">
        <Icon name="checkmark" /> gespeichert {{ time | date }}
      </template>
    </div>
    <div
        v-if="showComments"
        class="btn active"
        :class="{ 'comments-active': toggleComments }"
        title="Alle Kommentare ein- / ausblenden"
        @click="handleToggleComments"
    >
      <Icon name="comment" />
    </div>
    <template v-if="!noActions">
      <div
          class="btn active"
          title="Versionen anzeigen"
          @click="$emit('input', 'versions')"
      >
        <Icon name="versions" />
      </div>
      <div
        :class="{ btn: true, active: undos.length > 0 }"
        title="Widerrufen"
        @click="$emit('input', 'undo')"
      >
        <Icon name="undo"/>
      </div>
      <div
        :class="{ btn: true, active: redos.length > 0 }"
        title="Wiederherstellen"
        @click="$emit('input', 'redo')"
      >
        <Icon name="redo"/>
      </div>
    </template>
  </div>
</template>

<script>
  import Icon from '@/components/ui/Icon';
  import Format from '@/utils/Format';

  export default {
    name: 'UndoRedoSave',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      status: {
        type: String,
        default: null,
      },
      time: {
        type: Date,
        default: null,
      },
      undos: {
        type: Array,
        default: () => [],
      },
      redos: {
        type: Array,
        default: () => [],
      },
      noActions: {
        type: Boolean,
        default: false,
      },
      showComments: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        istatus: this.status || null,
        statusTimeout: null,
        toggleComments: false,
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      status(value) {
        clearTimeout(this.statusTimeout);
        this.istatus = value;
        if (value === 'updated') {
          this.statusTimeout = setTimeout(() => {
            this.istatus = 'idle';
          }, 2500);
        }
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {
      date(value) {
        return Format.toLocalizedDateTime(value);
      },
    },
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleToggleComments() {
        this.toggleComments = !this.toggleComments;
        this.$emit('input', 'toggle-comments');
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';
@import '~scss/animations';

.comp-undoredosave {
  display: inline-flex;
  align-items: center;
  height: inherit;

  & .status {
    height: 32px;
    display: inline-flex;
    align-items: center;
    @include font-body-small;
    color: $color-black-alpha-60;

    & > svg {
      position: relative;
      top: 2px;
      width: 16px;
      height: 16px;
      margin-right: 5px;
    }
    margin-right: 18px;

    &.updating {
      background-color: $color-signal-orange;
      color: $color-white-solid-10;
      border-radius: 2px;
      padding: 0 16px;

      & > svg {
        position: relative;
        top: 0;
        animation: spin 2s linear infinite;
      }
    }

    &.updated {
      background-color: $color-signal-green;
      color: $color-white-solid-10;
      border-radius: 2px;
      padding: 0 16px;
    }
  }

  & > .btn {
    position: relative;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    cursor: pointer;
    background-color: $color-black-solid-05;
    color: $color-black-alpha-60;
    border-radius: 2px;
    margin-right: 4px;
    &:last-of-type { margin-right: 0; }
    opacity: 0.5;
    pointer-events: none;

    & svg {
      width: 14px;
      height: 14px;
    }

    &.active {
      opacity: 1;
      pointer-events: all;
    }

    &.comments-active:after {
      position: absolute;
      top: 0;
      right: 0;
      width: 6px;
      height: 6px;
      background-color: $color-signal-green;
      border-radius: 50%;
      content: '';
    }
  }
}
</style>
